import React, { useState, useEffect, useCallback } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import '../styles.css';
import { handleActivation, getMyLicenses, handleUpdateActivation } from '../../../actions/license';
import { toast } from 'react-toastify';
import { dateFormat } from '../../../utils';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import CreateRoom from './createRoom';
import { useHistory } from 'react-router-dom';
import BackIcon from '../../../images/back-icon.png';
import LicenseModal from '../../Dashboard/components/ProductModel';

// const cardDetails1 = [ 'KonX eCard 1', 'KonX eCard 2', 'KonX eCard 3', 'KonX eCard 4', 'KonX eCard 5' ];
// const cardDetails2 = [ 'KonX eCard 6', 'KonX eCard 7', 'KonX eCard 8', 'KonX eCard 9', 'KonX eCard 10' ];

const PlanB = (props) =>
{
	const history = useHistory();
	const { planId, setPack } = props;
	const [ data, setData ] = useState({ loading: true, licenses: [] });
	const [ isOpen, setOpen ] = useState(false);
	const [ model, setModel ] = useState(false);
	const [ id, setId ] = useState('');

	const getData = () =>
	{
		getMyLicenses(planId).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res && res.status)
			{
				setData({ loading: false, licenses: [ ...res.data.data ] });
			}
			else
			{
				setData({ loading: false, licenses: [] });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				setData({ loading: false, licenses: [] });
			});
	};

	useEffect(() =>
	{
		if (planId && planId !== '')
		{
			getData();
		}
	}, [ planId ]);

	const handleActivate = (roomName) =>
	{
		const body = {
			roomName,
			planId,
			type : 'eCard'
		};

		handleActivation(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen(false);
				history.push(`/meet/${res?.data?.data?._id}`);
				// getData();
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});
	};

	const leftTime = (lic, allowedHours) =>
	{
		// const allowedHours = userType === 'SalesAgent' ? 50 : 60;

		if (lic?.duration > 0)
		{
			const diff = allowedHours*60 - lic.duration;

			let str = `${Math.floor(diff/60)} Hours`;

			str += Math.floor(diff%60) > 0 ? ` ${Math.floor(diff%60)} Minutes` : '';

			return str;
		}
		else
		{
			return `${allowedHours} Hours`;
		}
	};

	const remainingMinutes = (lic, allowedHours) =>
	{
		if (lic?.duration > 0)
		{
			const totalMinutes = allowedHours * 60;
			const remainingTime = totalMinutes - lic.duration;

			// Calculate the remaining time based on the specified interval

			return	remainingTime;

		}
		else
		{
			return allowedHours * 60;
		}
	};

	const loadECMonths = (f, t) =>
	{
		const _data = data.licenses.filter((item) => item.type === 'eCard');

		const licensesData = _data
			.filter((product) => product.expireDate !== null) // filter out products with non-null expireDate
			.slice(f, t + 1);

		const ele = licensesData.map((item, i) =>
		{
			return (
				item.expireDate !== null ?
					<div key={`EC_${i}`} className='flexMinWidthCol pdngSM'>
						<b className='textCntr'>{`KonX eCard ${i+1}`}</b>
						<div className='flexCol text-center alignCntr LinearGradientGreen whiteTxt py-2 brdrRadiusSM mrgnVSM purchaseCard'>
							<b className='textCntr'>{item.name}</b>
							Remaining : {leftTime(item, 80)}
							{remainingMinutes(item, 80)>0 &&<div className='displayHover' >
								<div className='d-flex w-100 justifyBtwn' >
									<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => setOpen({ status: true, type: 'eCard', data: item })}>
										<EditOutlinedIcon/>
										<span>Edit</span>
									</div>
									<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => { setId(item._id); setModel(true); }}>
										<VisibilityOutlinedIcon/>
										<span>View</span>
									</div>
								</div>
							</div>}
						</div>
					</div>
					:
					<div key={`EC_${i}`} className='flexMinWidthCol py-3 pdngSM'>
						<b className='textCntr'>{`KonX eCard ${i+1}`}</b>
						<div className='flexCol alignCntr cursor-pointer LinearGradientGreen brdrRadiusSM mrgnVSM' onClick={() => setOpen(true)}>
							<Button className='whiteTxt'>
								Activate
							</Button>
						</div>
					</div>
			);
		});

		let i = ele.length + f;

		while (i <= t)
		{

			ele.push(
				<div key={`EC_${i}`} className='flexMinWidthCol py-3 pdngSM'>
					<b className='textCntr'>{`KonX eCard ${i+1}`}</b>
					<div className='flexCol alignCntr cursor-pointer LinearGradientGreen brdrRadiusSM mrgnVSM' onClick={() => setOpen(true)}>
						<Button className='whiteTxt'>
							Activate
						</Button>
					</div>
				</div>
			);
			i++;
		}

		return ele;
	};

	const handleClose = () =>
	{
		setOpen(false);
	};

	const handleUpdate = useCallback((obj) =>
	{
		const body = {
			id   : obj.id,
			name : obj.name
		};

		handleUpdateActivation(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen({ status: false, type: null, data: null });
				getData();
				setOpen(false);
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});

	}, []);

	return (
		<div className='flexCol position-relative alignCntr baseBg fullHeight pdngXS dashboardCntnr'>
			{/* <div className='flexCol alignCntr whiteTxt
			LinearGradientGreen brdrRadiusSM pdngXS'>
				<h3 className='fontWeightNormal textCntr'>FEATURES OF KONX ECARDS PURCHASED</h3>
			</div> */}
			{setPack?
				<img className='backIcon' onClick={() => setPack('')} src={BackIcon} alt='Back'/>
				:null}
			<h3 className='textCntr pdngVMD bold'>KONX ECARD PACK FOR $500</h3>
			<div className='flexCol alignCntr pdngSM'>
				<ul className='flexCol alignCntr featuresCntnr pdngVSM'>
					<li className='flexRow justifyCntr textCntr '> Consist of 13 eCards</li>
					<li className='flexRow justifyCntr textCntr '> Good for 80 hours per KonX eCard</li>
					<li className='flexRow justifyCntr textCntr '> Up to 500 Participants / Meetings</li>
					<li className='flexRow justifyCntr textCntr '>  Use it ONLY when you need it!</li>
				</ul>
			</div>
			<div className='flexCol pdngVSM'>
				<div className='resRowColM'>
					{loadECMonths(0, 4)}
				</div>
				<div className='resRowColM'>
					{loadECMonths(5, 9)}
				</div>
				<div className='resRowColM'>
					{loadECMonths(10, 12)}
				</div>
			</div>
			{isOpen &&
				<CreateRoom
					open={isOpen} handleClose={handleClose} handleSave={handleActivate}
					name={'KonX eCard'}
					data={isOpen.data?isOpen.data:null}
					handleUpdate={handleUpdate}
				/>
			}
			<LicenseModal open={model} handleClose={() => setModel(false)} id={id}/>
			{/* <div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM mrgnTSM'>
				<h3 className='pdngXXS'>www.konx.biz</h3>
			</div> */}
		</div>
	);
};

export default PlanB;